export default __webpack_public_path__ + "static/media/peak_wood.9814d46e.png";